import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Mail, ChevronLeft, CheckCircle2 } from "lucide-react";
import api, { apiError } from "../lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setSent(true); // generic for security
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm fade-up">
        <div className="flex flex-col items-center mb-7">
          <div className="w-14 h-14 rounded-2xl bg-blue-600 grid place-items-center shadow-lg shadow-blue-600/40 mb-3">
            <Mail className="w-7 h-7 text-white" />
          </div>
          <h1 className="font-head text-2xl font-bold">Recupera password</h1>
          <p className="text-slate-500 text-sm mt-1 text-center">Inserisci la tua email: ti invieremo un link per reimpostare la password.</p>
        </div>

        {sent ? (
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 text-center" data-testid="forgot-success">
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-3" />
            <p className="text-sm text-slate-300">Se l'email è registrata, riceverai a breve le istruzioni per reimpostare la password. Controlla anche lo spam.</p>
            <button onClick={() => navigate("/admin/login")} className="mt-5 w-full bg-blue-600 hover:bg-blue-500 py-3 rounded-xl font-semibold" data-testid="back-to-login-btn">Torna al login</button>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-slate-900 border border-slate-800 rounded-2xl p-6 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" placeholder="nome@azienda.it"
                className="w-full mt-2 bg-slate-950 border-2 border-slate-600 rounded-xl px-3 py-3 text-sm text-slate-100 focus:outline-none focus:border-blue-500" required />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
              className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 py-3 rounded-xl font-semibold flex items-center justify-center gap-2">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : null} Recupera password
            </button>
          </form>
        )}

        <button onClick={() => navigate("/admin/login")} className="w-full flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-slate-300 mt-4">
          <ChevronLeft className="w-4 h-4" /> Torna al login
        </button>
      </div>
    </div>
  );
}
